// Third Party Imports
import React from 'react';
import Modal from '@homeaway/react-modal';

// Relative Imports
import './EditForm.less';

const EditForm = (props) => {
    const {
        handleOnClose,
        editModalBody,
        editModalHead,
        editModalFooter,
        showModal,
        isScrollTop,
        scrollModalToTop
    } = props;

    return (
        <Modal
            id="reviewEditModal"
            isOpen={showModal}
            onClose={handleOnClose}
            title={editModalHead}
            closeOnOutsideClick={false}
            scrollTop={isScrollTop}
            scrollToTop={scrollModalToTop}
        >
            <div className="edit-form">
                <div className="wrapper">
                    <div className="content-col">
                        {editModalBody}
                        {editModalFooter}
                    </div>
                </div>
            </div>
        </Modal>);
};

export default EditForm;
